module.exports = __webpack_public_path__ + "static/media/service-contract-vendor-engineer-licensing.539530bd.svg";